import { lecturerListForSelectQuery } from '@app-types/graphql-types';
import { HSMSSelectOption } from '@components/shared';

export const getLecturersForSelect = (lecturers: lecturerListForSelectQuery['lecturer']): HSMSSelectOption[] => {
  if (lecturers) {
    const lecturersForSelect = lecturers.map((lecturer) => {
      return {
        value: lecturer.id,
        label: `${lecturer.employeeID} - ${lecturer.firstName} ${lecturer.lastName}`,
      };
    });

    return lecturersForSelect.sort((firstValue, secondValue) => firstValue.label.localeCompare(secondValue.label));
  }

  return [];
};
